import React, { FC } from "react";
import NcdcRequestProgress from "./NcdcRequestProgress";
import classNames from "classnames";

type Props = {
    page: number;
    getPage: (seq: number) => void;
}

const NcdcRequestData: FC<Props> = ({page, getPage}) => {
    const goToPrev = () => {
        window.scrollTo(0, 0);
        getPage(page - 1);
    }

    const goToNext = () => {
        window.scrollTo(0, 0);
        getPage(page + 1);
    }

    return (
        <div className={classNames('ncdc-request-form-wrapper', {'no-show': page !== 5})}>
            <div className={'ncdc-request-form'}>
                <div className={'common-form-header-wrapper'}>
                    <span className={'common-form-header-title'}>데이터 신청</span>
                    <div className={'common-form-header-circle'} />
                </div>
                <NcdcRequestProgress seq={page - 1} />
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                신청 DB
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label className={'last'}>
                                    <span className={'common-form-input-label'}>
                                        연구 DB
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <span>중앙등록본부 DB</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-button-wrapper'}>
                    <div>
                        <button className={'common-button light'} onClick={goToPrev}>이전</button>
                    </div>
                    <div>
                        <button className={'common-button light'}>임시저장</button>
                        <button className={'common-button primary ml-10'} onClick={goToNext}>다음</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NcdcRequestData;
